import { Alert } from '@shared/components';

export default function ExamCenterDetailsInfoBanner() {
  return (
    <Alert
      severity='info'
      sx={(theme) => ({
        fontWeight: theme.typography.fontWeightRegular,
        padding: theme.spacing(3, 4),
      })}
    >
      ข้อมูลศูนย์ทดสอบที่กรอกจะถูกนำไปใช้แสดงบนใบรับรองผลการสอบ (Certificate)
      กรุณากรอกให้ถูกต้องทั้งภาษาไทยและภาษาอังกฤษ
    </Alert>
  );
}
